// publicチャットは分割モジュールで初期化します
$(document).on("turbolinks:load", function () {
  initChatWidget();
  initChatAutoRefresh();
  initChatWidgetDraggable();
});